module.exports = __webpack_public_path__ + "img/Logo-9.465945f1.svg";